import * as Yup from 'yup';

import { HelpTypes } from '@pharmaplan/common';
import strings from '../../../../localization';
import { formikRequired } from '../../SoftwareList/validator';

const requiredNumber = (field: string) =>
  Yup.number()
    .typeError(strings.pleaseEnterValidNumber)
    .required(strings.requiredField)
    .moreThan(
      0,
      strings.formatString(strings.pleaseEnterFormat, field) as string,
    );

const validator = () =>
  Yup.object().shape({
    name: Yup.string().trim().required(strings.requiredField),
    userType: formikRequired,
    promoHourlyRate: Yup.number()
      .nullable()
      .when('userType', {
        is: (userType: HelpTypes) =>
          userType === HelpTypes.pharmacy,
        then: () =>
          requiredNumber(strings.promoHourlyBonus),
      }),
    hourlyRateBonus: Yup.number()
      .nullable()
      .when('userType', {
        is: (userType: HelpTypes) =>
          userType === HelpTypes.technicians
          || userType === HelpTypes.pharmacist
          || userType === HelpTypes.students,
        then: () =>
          requiredNumber(strings.promoHourlyBonus),
      }),
    validityInDays: formikRequired,
    creditShiftCount: Yup.number()
      .typeError(strings.pleaseEnterValidNumber)
      .required(strings.requiredField)
      .integer(strings.pleaseEnterValidNumber)
      .moreThan(0, strings.pleaseEnterValidNumber),
  });

export default validator;
